import React, { memo, useEffect, useRef, useState } from 'react';
import AvatarEditor from 'react-avatar-editor';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import chroma from 'chroma-js';
import { StyledControls, StyledImageEditor, StyledImageWrapper, DropZoneWrapper } from './ImageEditor.Styles';
import { useTheme } from '@web/theme';
export var ImageEditor = memo(function (_a) {
    var _b, _c;
    var onChange = _a.onChange, height = _a.height, image = _a.image, innerRef = _a.innerRef, withGradient = _a.withGradient, noSlider = _a.noSlider, disableDrag = _a.disableDrag;
    var theme = useTheme();
    var _d = useState({ x: .5, y: .5 }), position = _d[0], setPosition = _d[1];
    var _e = useState({ w: 100, h: 100 }), dimensions = _e[0], setDimensions = _e[1];
    var _f = useState(100), scale = _f[0], setScale = _f[1];
    var refWrapper = useRef(null);
    useEffect(function () {
        if (refWrapper.current) {
            setDimensions({ w: refWrapper.current.clientWidth, h: refWrapper.current.clientHeight });
        }
    }, [(_b = refWrapper === null || refWrapper === void 0 ? void 0 : refWrapper.current) === null || _b === void 0 ? void 0 : _b.clientWidth, (_c = refWrapper === null || refWrapper === void 0 ? void 0 : refWrapper.current) === null || _c === void 0 ? void 0 : _c.clientHeight, height]);
    var _onPositionChange = function (position) { return !disableDrag && setPosition(position); };
    return (React.createElement(StyledImageEditor, null,
        React.createElement(StyledImageWrapper, { ref: refWrapper, style: { width: '100%', height: height + "px" } },
            React.createElement(AvatarEditor, { ref: innerRef, crossOrigin: "", image: image, width: dimensions.w, height: dimensions.h, border: 0, color: [255, 255, 255, 1], scale: scale / 100, rotate: 0, position: position, onPositionChange: _onPositionChange }),
            React.createElement(DropZoneWrapper, null,
                React.createElement("input", { type: "file", accept: "image/*", name: "droppedFiles", onChange: onChange }),
                React.createElement("input", { type: "text", name: "backgroundImage", value: image, onChange: onChange })),
            !noSlider &&
                React.createElement(StyledControls, null,
                    React.createElement(Slider, { min: 100, max: 300, step: 1, onChange: function (value) { return setScale(parseFloat(value)); } }))),
        withGradient &&
            React.createElement("div", { style: {
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: "linear-gradient(to bottom, " + chroma(theme.page.bg).alpha(0).hex() + " 30%, " + theme.page.bg + ")",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                } })));
});
